import React from 'react';

import classes from "./Navbar.css";
import Logo from './Logo/Logo';
import SearchBar from './SearchBar/SearchBar';
import LeadingControl from './LeadingControl/LeadingControl';
const Navbar = (props) => {
    return (
        <React.Fragment>
            <div className={classes.NavbarReserved}>
            </div>
            <div className={classes.Navbar}>

                <Logo style={{ "flex": "1" }} />
                <SearchBar style={{ "flex": "3" }} />
                <LeadingControl />
            </div>
        </React.Fragment>
    );
}

export default Navbar;